import React from 'react'
import moment from 'moment'
import * as css from '../../asignacion-fondos/Fondos.css'
import * as csx from '../../../auditorias/revision/PanelAuditoria.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

let PropTypes = React.PropTypes
moment.locale('es')
import { ModalTrigger, RechazarGasto} from './Modales.jsx'
let labelEstado = [
    'label-default',    
    'label-info',    
    'label-success',  
    'label-warning'
]
let textoEstado = [
    '',        
    'Pendiente',       
    'Aprobado',      
    'Rechazado'
]

export class RowDetail extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <tr key={this.props.index}>
                <td className={css.tdIndex}>{this.props.index+1}</td>
                <td>
                    <a
                        className={cx(
                            'label',
                            labelEstado[this.props.gasto.id_estado_gasto]
                            
                        )}
                    >
                        {textoEstado[this.props.gasto.id_estado_gasto]}
                    </a>
                </td>
                <td className={css.tdFecha}>{this.props.gasto.fecha_emision}</td>
                <td className={css.tdFecha}>{this.props.gasto.total_format}</td>
                <td className={css.tdLocal}>{this.props.gasto.tipo_documento}</td>
                <td className={css.tdLocal}>{this.props.gasto.tipo_gasto}</td>
                <td className={css.tdLocal}>{this.props.gasto.glosa}</td>
                <td className={css.tdStock}>
                    <p className={csx.tooltip}>
                        <span className={"glyphicon glyphicon-search " +csx.glyphiconStock}></span>
                        <span className={csx.tooltiptext}>
                        <img src={`${this.props.gasto.foto_documento}`} className={csx.imagenStock}/>
                        </span>
                    </p>
                </td>
                <td>
                    <button
                        type="button" className="btn btn-xs btn-success"
                        onClick={() => this.context.aprobarGasto(this.props.gasto.idGastoRendicion)}
                    >Aprobar
                    </button>
                </td>
                <td>
                    <ModalTrigger>
                        {(isVisible, showModal, hideModal)=>
                            <button className={"btn btn-xs btn-danger"} onClick={showModal}>
                                Rechazar
                                {isVisible && <RechazarGasto
                                    hideModal={hideModal}
                                    idGasto={this.props.gasto.idGastoRendicion}
                                />}
                            </button>
                        }
                    </ModalTrigger>
                </td>
            </tr>
        )
    }
}
RowDetail.contextTypes = {
    aprobarGasto: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/contabilidad/revision-rendiciones/detalle-rendicion/RowDetail.jsx